import { useEntityPageContext } from './EntityContext';

/**
 * One week-scoped series for the chart, in the shape the chart components take.
 * A plain function, so a page that needs a different series builds its own.
 */
export const weeklySeries = ({ page, color, ...rest }) =>
    page.series && page.series.length
        ? [
              {
                  id: `${page.entityType === 'brands' ? 'brand' : 'category'}-${page.entityId}`,
                  name: page.timeSeriesName,
                  timeSeries: page.series,
                  color,
                  ...rest,
              },
          ]
        : null;

/**
 * The Instagram and TikTok chart shape: the same props, a different chart and
 * a different metric label.
 */
const WeeklyEntityChart = ({ as: Chart, data, seriesQuery, ...rest }) => {
    const {
        row,
        week,
        year,
        isLoading,
        country,
        entityId,
        entityType,
        timeSeriesRef,
    } = useEntityPageContext();

    return (
        <Chart
            data={data}
            metrics={row || {}}
            week={week}
            year={year}
            isLoading={seriesQuery?.isLoading || isLoading}
            country={country?.id}
            {...(entityType === 'brands'
                ? { brand: entityId }
                : { category: entityId })}
            ref={timeSeriesRef}
            {...rest}
        />
    );
};

export default WeeklyEntityChart;
